<template>
  <v-text-field :readonly="readonly" v-model.number="value" :label="prop.text" type="number" :id=prop.value
    :clearable="!readonly" :mask=prop.mask :color="prop.color" :step="prop.step" :min="prop.minValue" :name="prop.text"
    :error-messages="error" :max="prop.maxValue">

  </v-text-field>
</template>

<style scoped>

</style>

<script>
  import NumberInput from "./numberInput.ts";
  export default NumberInput;
</script>